import { REHYDRATE } from 'redux-persist';

const INITIAL_STATE = { list: {} };
const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REHYDRATE:
      if (!action.payload) {
        return state;
      }
      return {
        ...action.payload.categoryState
      };
    case 'CATEGORY_ADD':
      return { ...state, [action.category.key]: action.category };
    default:
      return state;
  }
};

export default reducer;
